import React, { useEffect, useState } from 'react';
import emailjs from 'emailjs-com';
import './QuotesPage.css';

const QuotesPage = () => {
  const [quotes, setQuotes] = useState([]);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const savedQuotes = JSON.parse(localStorage.getItem('quotes')) || [];
    setQuotes(savedQuotes);
  }, []);

  const removeQuote = (id) => {
    const updatedQuotes = quotes.filter(q => q.id !== id);
    setQuotes(updatedQuotes);
    localStorage.setItem('quotes', JSON.stringify(updatedQuotes));
  };

  const updateQuantity = (id, newQuantity) => {
    const updatedQuotes = quotes.map(q =>
      q.id === id && newQuantity > 0 ? { ...q, quantity: parseInt(newQuantity) } : q
    );
    setQuotes(updatedQuotes);
    localStorage.setItem('quotes', JSON.stringify(updatedQuotes));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email) {
      alert('Please fill out your name and email.');
      return;
    }

    setIsSubmitting(true);

    try {
      // Generate the email content with an HTML table for quotes
      const quotesTable = quotes
        .filter(q => q.name && q.quantity)
        .map((q, index) => 
          `<tr>
            <td>${index + 1}</td>
            <td>${q.name}</td>
            <td>${q.quantity}</td>
          </tr>`
        )
        .join('');

      const emailContent = `
        <h3>Quote Request</h3>
        <p><strong>Name:</strong> ${name}</p>
        <p><strong>Email:</strong> ${email}</p>
        <p><strong>Message:</strong> ${message || "No message provided"}</p>
        <h4>Quote Items:</h4>
        <table border="1" cellpadding="5" cellspacing="0">
          <thead>
            <tr>
              <th>#</th>
              <th>Product Name</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            ${quotesTable}
          </tbody>
        </table>
      `;

      // Send the email using EmailJS
      const result = await emailjs.send(
        'service_4kc4zt3', // Your EmailJS service ID
        'template_xzj5y3s', // Your EmailJS template ID
        {
          name,
          email,
          message,
          emailContent, // Include the generated HTML content
        },
        'WxygiWhz-pXXcFtzb' // Replace with your public key from EmailJS
      );

      console.log(result.text);
      alert('Quote request sent successfully!');
      localStorage.removeItem('quotes');
      setQuotes([]);
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error('Error sending quote:', error);
      alert('Error sending quote request. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="quotes-page">
      <h1>Your Quotes</h1>

      {quotes.length === 0 ? (
        <p>No products in your quote list.</p>
      ) : (
        <>
          <div className="quotes-list">
            {quotes.map((product) => {
              if (!product.name || !product.id) {
                console.error("Invalid product:", product);
                return null;
              }
              return (
                <div key={product.id} className="quote-item">
                  <h3>{product.name}</h3>
                  <p>{product.description}</p>
                  <div className="quote-controls">
                    <label>Quantity: </label>
                    <input
                      type="number"
                      min="1"
                      value={product.quantity}
                      onChange={(e) => updateQuantity(product.id, e.target.value)}
                    />
                    <button onClick={() => removeQuote(product.id)}>Remove</button>
                  </div>
                </div>
              );
            })}
          </div>

          <form className="quote-form" onSubmit={handleSubmit}>
            <h2>Submit Your Quote Request</h2>
            <div className="form-group">
              <label>Name:</label>
              <input 
                type="text" 
                value={name} 
                onChange={(e) => setName(e.target.value)} 
                required 
              />
            </div>
            <div className="form-group">
              <label>Email:</label>
              <input 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
              />
            </div>
            <div className="form-group">
              <label>Message (optional):</label>
              <textarea 
                value={message} 
                onChange={(e) => setMessage(e.target.value)}
                rows="4"
              ></textarea>
            </div>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Submit Quote'}
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default QuotesPage;
